import { render, staticRenderFns } from "./InternetTvDetails.vue?vue&type=template&id=104d1894&scoped=true&"
import script from "./InternetTvDetails.vue?vue&type=script&lang=ts&"
export * from "./InternetTvDetails.vue?vue&type=script&lang=ts&"
import style0 from "./InternetTvDetails.vue?vue&type=style&index=0&id=104d1894&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "104d1894",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/0/37614586/myshop/myshop/myshop/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('104d1894')) {
      api.createRecord('104d1894', component.options)
    } else {
      api.reload('104d1894', component.options)
    }
    module.hot.accept("./InternetTvDetails.vue?vue&type=template&id=104d1894&scoped=true&", function () {
      api.rerender('104d1894', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/main/webapp/WEB-INF/views/orange/broadband/internet/showcase/components/InternetTvDetails.vue"
export default component.exports